/**
 * רמות הסכמה שיווקית — סמנטיקה בינארית (0 / 1) על פי `marketingConsentLevel` ב-API:
 *   0 = ללא הסכמה (אין שליחת תפוצה).
 *   1 = הסכמה מלאה.
 *
 * המודל הקודם תמך ב-3 רמות (`none` / `service_only` / `full`) אבל הפרונט החדש
 * מציג רק שתי בחירות; ההמרה במיגרציה (Funner_APP3) מיפתה את כל ה-1 הישנים ל-0
 * ואת ה-2 ל-1, אז ערכים מחוץ לטווח אינם אמורים להגיע יותר.
 */
export type CustomerMessagingKind = 'none' | 'full';

/**
 * ברירת המחדל לאיש קשר חדש (ייבוא אקסל, רשימת תפוצה, יצירה ידנית) — הסכמה מלאה,
 * כדי שניתן יהיה לכלול אותו ברשימות תפוצה מיד לאחר היצירה.
 */
export const DEFAULT_MARKETING_CONSENT_LEVEL = 1;

export function resolveCustomerMessagingKind(row: Record<string, unknown>): CustomerMessagingKind {
  const levelRaw = row.marketingConsentLevel;
  const n = levelRaw === null || levelRaw === undefined ? null : Number(levelRaw);
  // רק 0 מפורש = "לא מסכים" — מיושר עם אכיפת השרת (Block 7): NULL/ערך לא מוכר
  // אינם סירוב. איש קשר חדש = מסכים כברירת מחדל (הוחלט 27.08).
  return n === 0 ? 'none' : 'full';
}

/** הסכמה מלאה לשיווק; דורש אזהרה על הסכמת לקוח. */
export function isLenientMessagingKind(kind: CustomerMessagingKind): boolean {
  return kind === 'full';
}

export function kindToApiPayload(kind: CustomerMessagingKind): { marketingConsentLevel: number } {
  return { marketingConsentLevel: kind === 'full' ? 1 : 0 };
}
